import React from 'react';
import './AboutSection.css';

const AboutSection = ({ id, title, backgroundColor, content }) => {
  return (
    <div id={id} className="about-section">
      <div class="text-section">
        <h2>Über mich</h2>
        <p>
          Mein Name ist Samuel Hawlik, und ich bin als leidenschaftlicher Gärtner im Raum Lindau (Bodensee) tätig. 
          <br>
          </br>
          <br></br>
          Mit großer Liebe zur Natur und tiefem Verantwortungsbewusstsein für unseren Planeten sehe ich meine Arbeit als Berufung, der ich mit Sorgfalt und Hingabe nachgehe.
          <br></br>
          <br></br>
          Durch meine langjährige Erfahrung durfte ich bereits mit den unterschiedlichsten Böden, Pflanzen und Gartensituationen arbeiten und dabei wertvolle Kenntnisse sammeln.
          <br></br>
          <br></br>
          Wenn ich Ihr Interesse geweckt habe, finden Sie unten meine Kontaktdaten sowie eine Übersicht über alle Leistungen, die ich anbiete.
        </p>
      </div>

      <div class="image-section">
        <img src="/images/beste.JPG" alt="Image" />
      </div>
      
    </div>
  );
};

export default AboutSection;